import { jwtDecode } from "jwt-decode";
import type { RedactoJwtPayload } from "../api/types";

/**
 * Decode JWT with error handling — returns null on failure.
 */
export function decodeTokenSafely(token: string): RedactoJwtPayload | null {
  try {
    return jwtDecode(token) as RedactoJwtPayload;
  } catch (error) {
    console.warn("Failed to decode JWT token:", error);
    return null;
  }
}
